@use '@/sass/variables';

.ui__switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .ui__switch__slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: variables.$silver;
    transition: 0.2s;
    border-radius: 20px;

    &:before {
      position: absolute;
      content: '';
      height: 16px;
      width: 16px;
      left: 3px;
      bottom: 2px;
      background-color: white;
      transition: 0.2s;
      border-radius: 50%;
    }
  }

  input:checked + .ui__switch__slider {
    background-color: variables.$blue;
  }

  input:checked + .ui__switch__slider:before {
    transform: translateX(14px);
  }
}
